<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card/-header-primary card-header-icon">
        <div class="card-icon">
          <i class="material-icons">
            snippet_folder
            </i>
        </div>
        <h4 class="card-title">Centralized Files</h4>
      </div>
      <div class="card-body">

        <div class="toolbar">
          <div class="row">

            <div class="col-md-2">
              <mat-form-field class="example-full-width">
                <mat-label>PO#</mat-label>
                <input matInput name="filterpo" [(ngModel)]="ponumber" (keyup.enter)="getFolders()">
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <button mat-raised-button class="btn btn-info btn-md" (click)="getFolders()" [disabled]="ponumber === '' || loading">
                <span class="btn-label">
                  <i class="material-icons">search</i>
                </span>
                Search
              </button>
            </div>

          </div>
        </div>

        <div *ngIf="loading" style="text-align: center">
          <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
        </div>

        <dinamic-table
          *ngIf="!loading && flat"
          [id]="'centralizedfile'"
          [data]="data"
          [frontpaginate]="true"
          (action_button)="action($event)"
        ></dinamic-table>

      </div>
    </div>
  </div>
</div>